import { AfterViewInit, Component, OnInit, Renderer2, ViewChild, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router, RouterModule, RouterOutlet } from '@angular/router';
import { LayoutModule } from './layout/layout.module';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { LoaderService } from './common/services/loader';
import { LoaderModule } from './common/components/loader/loader.module';
import { CommonModule } from '@angular/common';
import { ConsentToAccessService } from './module/consent-to-access/consent-to-access.service';
import { LoginService } from './common/services/login.service';
import IdleTimer from '../app/IdleTimer'
import { ToastComponent } from './common/components/toast/toast.component';
import { ChatbotComponent } from './common/components/chatbot/chatbot.component';
import { CaptchaComponent } from './common/components/captcha/captcha.component';
import { Meta, Title } from '@angular/platform-browser';
import { filter, Subscription } from 'rxjs';
import { DevelopmentService } from './common/services/development.service';
import { TextToSpeechService } from './common/services/text-to-speech.service';
import { LanguageService } from './common/services/language.service';

declare const bootstrap: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule, LayoutModule, LoaderModule, CommonModule, ToastComponent, ChatbotComponent],
  providers: [CaptchaComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [
    trigger('fadeInOut', [
      state('true', style({ opacity: 1 })),
      state('false', style({ opacity: 0 })),
      transition('false => true', animate('0ms ease-in')),
      transition('true => false', animate('100ms ease-in-out'))
    ]),
  ]

})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'MH_UCDH';
  cssLoaded = false;
  constructor(
    public loaderService: LoaderService,
    private router: Router,
    private consentDataAcess: ConsentToAccessService,
    private authenticationService: LoginService,
    private titleService: Title,
    private metaService: Meta,
    private renderer: Renderer2,
    private DS: DevelopmentService,
    private textToSpeechService: TextToSpeechService,
    private cdr: ChangeDetectorRef,
      private ngZone: NgZone,
    private langService: LanguageService

  ) {

  }

  private titleSubscription: Subscription;

  private applyPageTitle(titleKey: string): void {
    this.titleSubscription?.unsubscribe();
    if (!titleKey) return;
    this.titleSubscription = this.langService.getTranslation(titleKey).subscribe(translated => {
      setTimeout(() => this.titleService.setTitle(translated));
    });
  }

  async ngOnInit(): Promise<void> {
  // document.addEventListener('contextmenu', (event) => {
  //   event.preventDefault();
  //   alert('Security policy: Right-click is disabled on this application.');
  // });
    this.checkCSSLoaded();
    this.consentDataAcess.getIPAddress().subscribe((data: any) => {
      sessionStorage.setItem('ipaddrss', data.ip);
    })
    //this.getAccessTokenTime();
    await this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationStart) {
        await this.loaderService.show(0);
      } else if (event instanceof NavigationEnd || event instanceof NavigationError) {
        await this.loaderService.hide();
      }
    });
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const rt = this.getChild(this.router.routerState, this.router.routerState.root);
      rt.data.subscribe(data => {
        this.applyPageTitle(data.title);
        if (data.description) {
          this.metaService.updateTag({ name: 'description', content: data.description });
        }
        // Add more meta tags as needed
        if (data.breadcrumb) {
          this.metaService.updateTag({ name: 'breadcrumb', content: data.breadcrumb });
        }
      });
      const navbarSupportedContent = document.getElementById('main-menu');
      if (navbarSupportedContent && navbarSupportedContent.classList.contains('show')) {
        const bsCollapse = new bootstrap.Collapse(navbarSupportedContent, {
          toggle: false
        });
        bsCollapse.hide();
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // Logic to Initialize Text to Speech Feature......
    this.textToSpeechOnTextHover();
  }
  checkCSSLoaded() {
    setTimeout(() => {
      this.cssLoaded = true;
    }, 500);
  }

  async ngAfterViewInit(): Promise<void> {
    this.DS.initializeTooltips();
         this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
         const script = this.renderer.createElement('script');
    script.src = '';
    script.async = true;
    script.setAttribute('language-icon-color', '#ffffff');
    //script.setAttribute('initial_preferred_language', 'mr');
    script.setAttribute('page-source-language', 'mr');
    this.renderer.appendChild(document.body, script);
      }, 3000);
    });
    //sessionStorage.setItem('preferredLanguage','mr');
  }



  accessTokenTime: number = 1000;
  //To check user is Idle or not
  public timer: any;
  public minte: number = 5;
  public warningTime: number = 2; // Refresh token 2 minutes before expiration

  public getAccessTokenTime() {
    // this.clientService.readCyberSecurityData(clientobject).subscribe((data:any) => {
    // if(data.length==2){

    this.accessTokenTime = (this.minte) * 60; //Convert the data from Minute to Seconds
    sessionStorage.removeItem("_expiredTime");
    //sessionStorage.setItem("_expiredTime", (Date.now() + this.accessTokenTime * 1000).toString());
    this.timer = new IdleTimer({
      timeout: this.accessTokenTime, //expired time in second
      warningTime: this.warningTime * 60, // 2 minutes before expiration
      onTimeout: () => {
        var data: any = sessionStorage.getItem('userData');
        data = JSON.parse(data);
        //console.log(this.authenticationService.IDAMlogOut(data.idToken));
        this.authenticationService.IDAMlogOut(data.idToken);
        sessionStorage.removeItem("userData");
        this.router.navigate(['/home/landing']);
      },
      refreshtoken: () => {
        this.authenticationService.refreshToken();
      },
      router: this.router, // Pass the router to track route changes
    });

    // }
    //});
  }
  getChild(state, parent) {
    if (parent && parent.firstChild) {
      return this.getChild(state, parent.firstChild);
    } else {
      return parent;
    }
  }

  // For Text to Speech Funcitonality
  private textToSpeechOnTextHover() {
    // Hover to speak
    // this.renderer.listen('document', 'mouseover', (event: MouseEvent) => {
    this.renderer.listen('document', 'mouseover', (event: any) => {
      // console.log(event.target);
      if (this.textToSpeechService.isEnabled() && event.target instanceof HTMLElement) {
        const text = event.target.innerText.trim();
        if (text) {
          this.textToSpeechService.speak(text);
        }
      }
    });
    // Detect DevTools Keyboard Shortcuts
  this.renderer.listen('document', 'keydown', (event: KeyboardEvent) => {

    if (
      event.key === 'F12' ||
      (event.ctrlKey && event.shiftKey && event.key === 'I') ||
      (event.ctrlKey && event.shiftKey && event.key === 'J') ||
      (event.ctrlKey && event.shiftKey && event.key === 'C') ||
      (event.ctrlKey && event.key === 'U')
    ) {
      event.preventDefault();
      alert('Security policy: Developer tools are restricted.');
    }

  });

  // Your existing Text-to-Speech logic
  this.renderer.listen('document', 'mouseover', (event: any) => {

    if (
      this.textToSpeechService.isEnabled() &&
      event.target instanceof HTMLElement
    ) {
      const text = event.target.innerText.trim();

      if (text) {
        this.textToSpeechService.speak(text);
      }
    }

  });

    // Text selection to speak
    // this.renderer.listen('document', 'mouseup', () => {
    //   if (this.textToSpeechService.isEnabled()) {
    //     const selectedText = window.getSelection()?.toString().trim();
    //     if (selectedText) {
    //       this.textToSpeechService.speak(selectedText);
    //     }
    //   }
    // });
  }
}
